import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FreightScreen, type FreightView } from '@/features/buying/freight/FreightScreen';

/**
 * /purchasing/freight — trips from the drop-off locations and their freight (TASK-0257, DROP-2a). Un-nested
 * from /purchasing (the `_` suffix) like Follow-ups, so it does not inherit the PO list's search schema.
 */
export const Route = createFileRoute('/_app/purchasing_/freight')({
  staticData: { crumb: 'Freight' },
  validateSearch: (
    s: Record<string, unknown>
  ): { week?: number; view?: FreightView; invoice?: number; month?: number } => {
    const w = Number(s.week);
    const m = Number(s.month);
    const inv = Number(s.invoice);
    const view = s.view === 'place' || s.view === 'month' ? s.view : undefined;
    return {
      week: Number.isInteger(w) && w !== 0 && Math.abs(w) <= 104 ? w : undefined,
      ...(view ? { view } : {}),
      ...(Number.isInteger(inv) && inv > 0 ? { invoice: inv } : {}),
      ...(Number.isInteger(m) && m < 0 && m >= -24 ? { month: m } : {}),
    };
  },
  component: FreightRoute,
});

function FreightRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <FreightScreen
      week={search.week ?? 0}
      onWeek={(week) =>
        void navigate({
          search: (prev) => ({ ...prev, week: week === 0 ? undefined : week }),
        })
      }
      view={search.view ?? 'trips'}
      onView={(view) =>
        void navigate({
          search: (prev) => ({
            ...prev,
            view: view === 'trips' ? undefined : view,
            invoice: undefined,
          }),
        })
      }
      invoiceId={search.invoice ?? null}
      onShowAllBills={() =>
        void navigate({ search: (prev) => ({ ...prev, invoice: undefined }) })
      }
      month={search.month ?? 0}
      onMonth={(month) =>
        void navigate({
          search: (prev) => ({ ...prev, month: month === 0 ? undefined : month }),
        })
      }
    />
  );
}
